export const TAX_SETTINGS_RESET_STATE = 'TAX_SETTINGS_RESET_STATE';
export const TAX_SETTINGS_CURRENT_ITEM = 'TAX_SETTINGS_CURRENT_ITEM';

export const TAX_SETTINGS_REQUEST_LOADING = 'TAX_SETTINGS_REQUEST_LOADING';
export const TAX_SETTINGS_REQUEST_SUCCESS = 'TAX_SETTINGS_REQUEST_SUCCESS';
export const TAX_SETTINGS_REQUEST_FAILED = 'TAX_SETTINGS_REQUEST_FAILED';

export const TAX_SETTINGS_CURRENT_ACTION = 'TAX_SETTINGS_CURRENT_ACTION';
export const TAX_SETTINGS_RESET_ACTION = 'TAX_SETTINGS_RESET_ACTION';